import { Pipe, PipeTransform } from '@angular/core';
import { Data } from 'emoji-mart';

import { EmojisService } from 'src/services/emojis.service';

@Pipe({
  name: 'colonToEmoji',
  standalone: true,
  pure: false,
})
export class ColonToEmojiPipe implements PipeTransform {
  constructor(private emojisService: EmojisService) {}

  transform(value: string | null | undefined): string {
    if (!value) {
      return '';
    }

    // required to prevent race conditions
    if (!this.emojisService.getIsLoaded()) {
      return value;
    }

    const colonRegex = /:([a-zA-Z0-9_+-]+):/g;

    // Ensure emojis are loaded. Note: This might introduce a delay if emojis aren't pre-loaded.
    // Consider if EmojisService needs a synchronous way to get pre-loaded emojis or if the component
    // using this pipe should ensure emojis are loaded beforehand.
    // For now, we assume getReactionEmoji can be called and will work if emojis are loaded.

    const processedValue = value.replace(colonRegex, (match, emojiId) => {
      // Use EmojisService to get the native emoji or custom emoji URL (or the colon string back if not found)
      const resolvedEmoji = this.emojisService.getReactionEmoji(emojiId);
      return resolvedEmoji;
    });

    return processedValue;
  }
}
